// Helper for computing the locale-prefixed `/login` URL used after logout
// and from unauthenticated navigations. Reads the persisted i18next locale
// from localStorage (key `bloom-language`, set in src/i18n/index.js).
import { localePath, SUPPORTED_LOCALES, DEFAULT_LOCALE } from '../constants/Routes';

export function getLogoutRedirect() {
  const stored = localStorage.getItem('bloom-language');
  const locale = SUPPORTED_LOCALES.includes(stored) ? stored : DEFAULT_LOCALE;
  return localePath(locale, '/login');
}
